export default class Tooltips {
    constructor( tooltip ) {
        if ( !tooltip ) {
            return;
        }

        // Variables.
        this.open = false;
        this.toggle = tooltip?.querySelector( '[aria-expanded]' );
        this.tooltip = tooltip;

        this.events();
    }

    /**
     * Firing the events.
     */
    events() {
        if( !this.toggle ) {
            return;
        }

        // Toggle.
        this.toggle.onclick = ( e ) => {
            // Make sure we don't submit the form when the tooltip is within a form.
            e.preventDefault();
            this.toggleStatus();
        };

        // Open.
        this.toggle.onmouseenter = () => this.openTooltip();

        // Close.
        this.toggle.onblur = () => this.closeTooltip();
        this.toggle.onmouseleave = () => this.closeTooltip();

        // Close on escape-key.
        window.addEventListener('keyup', (e) => {
            if ( 'Escape' === e.key && !! this.open ) {
                this.closeTooltip();
            }
        })
    }

    /**
     * Toggle the tooltip status.
     */
    toggleStatus() {
        this.open = !this.open;

        if ( !!this.open ) {
            this.openTooltip();
        } else {
            this.closeTooltip();
        }
    }

    /**
     * Force open.
     */
    openTooltip() {
        if( !this.toggle ) {
            return;
        }

        this.open = true;
        this.toggle.setAttribute( 'aria-expanded', true );
        this.tooltip.classList.add('tooltip--active');
    }

    /**
     * Force Close.
     */
    closeTooltip() {
        if( !this.toggle ) {
            return;
        }

        this.open = false;
        this.toggle.setAttribute( 'aria-expanded', false );
        this.tooltip.classList.remove('tooltip--active');
    }
}
